
const digest = 'ed1700823131931ee932d9f2ee98e3ab97404f9dafdb695c12be41fc1c161e95';
const classes = {"wrapper":"_wrapper_flnz9_1","content":"_content_flnz9_11","title":"_title_flnz9_17","items":"_items_flnz9_22","itemWrapper":"_itemWrapper_flnz9_26","item":"_item_flnz9_22","value":"_value_flnz9_43","controls":"_controls_flnz9_48","button":"_button_flnz9_62","userGroupListCol1":"_user-group-list-col-1_flnz9_1","userGroupListCol2":"_user-group-list-col-2_flnz9_1","userGroupListCol3":"_user-group-list-col-3_flnz9_1"};
const css = `._wrapper_flnz9_1 {
  display: flex;
  flex-direction: row;
  background-color: #ffffff;
  border: 1px solid #eaedf3;
  margin: 10px 0;
}
._wrapper_flnz9_1:first-of-type {
  margin-top: 0;
}
._wrapper_flnz9_1 ._content_flnz9_11 {
  flex-grow: 1;
  padding: 24px 40px;
  display: flex;
  flex-direction: column;
}
._wrapper_flnz9_1 ._content_flnz9_11 ._title_flnz9_17 {
  color: #000000;
  font-weight: 500;
  font-size: 16px;
}
._wrapper_flnz9_1 ._content_flnz9_11 ._items_flnz9_22 {
  display: flex;
  flex-direction: row;
}
._wrapper_flnz9_1 ._content_flnz9_11 ._itemWrapper_flnz9_26 {
  display: flex;
  flex-direction: column;
  padding-right: 24px;
  border-right: 1px solid #eaedf3;
  gap: 10px;
  margin-top: 10px;
}
._wrapper_flnz9_1 ._content_flnz9_11 ._itemWrapper_flnz9_26 ._item_flnz9_22 {
  display: flex;
  flex-direction: column;
}
._wrapper_flnz9_1 ._content_flnz9_11 ._itemWrapper_flnz9_26 ._item_flnz9_22 ._title_flnz9_17 {
  color: #9ea0a5;
  font-size: 14px;
  font-weight: 400;
}
._wrapper_flnz9_1 ._content_flnz9_11 ._itemWrapper_flnz9_26 ._item_flnz9_22 ._value_flnz9_43 {
  color: #3e3f42;
  font-size: 14px;
  font-weight: 500;
}
._wrapper_flnz9_1 ._controls_flnz9_48 {
  border-left: 1px solid #eaedf3;
  padding: 24px;
  display: flex;
  flex-direction: column;
  min-width: 205px;
  gap: 5px;
}
._wrapper_flnz9_1 ._controls_flnz9_48 ._title_flnz9_17 {
  font-size: 14px;
  font-weight: 400;
  color: #9ea0a5;
  margin-bottom: 10px;
}
._wrapper_flnz9_1 ._controls_flnz9_48 ._button_flnz9_62 {
  margin-top: 10px;
}

#_user-group-list-col-1_flnz9_1 {
  min-width: 288px;
}

#_user-group-list-col-2_flnz9_1 {
  min-width: 288px;
  padding-left: 24px;
}

#_user-group-list-col-3_flnz9_1 {
  border-right: 0;
  padding-left: 24px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  